import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {useApplicationStore} from '../home/ApplicationStore';
import {useWebViewStore,useStore} from "../webview/useWebViewStore";
import launchExternal from '../../util/launchExternal';
import { IUserIPRestrictionEntity } from '../dealer-admin/ip-access/IPRestrictionInterface';
import { useIPRestrictionStore } from "../dealer-admin/ip-access/IPRestrictionStore";
import { useStartupWorkflowStore } from '../startup-app/StartupWorkflowStore';

const isIpRestricted = (ipRestriction:IUserIPRestrictionEntity[], appId:string) =>{
  const data = ipRestriction?.some(
    (item:IUserIPRestrictionEntity) => item.entityType === 'application' 
    && item.entityId === appId 
    && item.isRestricted
  );
  return data;
}

export function AppView() {
  const { appId, dpLink } = useParams() as any;
  const { applications } = useApplicationStore();
  const {fromUniversity} = useParams() as any;
  const {addWebView,removeWebView,webviews,resetActive} = useWebViewStore();
  const {setIsLoading,setName} = useStore() as any;
  const ipRestriction = useIPRestrictionStore((state:any) => state.ipRestriction);
  
  useEffect(()=>{
    if(appId){
        const app = applications?.find((app: any) => app.id === appId);
        if(!app){
          return;
        }
        const isRestricted = isIpRestricted(ipRestriction,appId);
        if(isRestricted){
          return;
        }
        const isLaunced = launchExternal(app.url);
        const isExist = webviews.some((i) => i.id === app.id);
        if(!isExist && !isLaunced){
          setIsLoading(true);
          let viewName =app.name+" Application";
          fromUniversity === 'Y' && (viewName = app.name + " - CDK University");
          setName(viewName);
        }

        let dpLinkUrl = '';
        if(dpLink){
          try{
            dpLinkUrl = JSON.parse(atob(window.location?.href.split('bdp')[1] || '{}'))?.url;
          } catch(_) {
            if(window.top){
              window.top.location.href = window.top.location.origin;
            }
            return;
          }
        }

        if(fromUniversity === 'Y'){
          const cdkuApp = applications?.find((app: any) => app.id === 'CDKU');
          const view = { id:cdkuApp.id, deepLink: dpLinkUrl, type:'application', name:cdkuApp.name, url:app.cdkuUrl, icon:cdkuApp.icon,iconText:cdkuApp.iconText, 
            logoutUrl: cdkuApp.logoutUrl };
          resetActive();addWebView(view);
        }else{
          const wview = webviews.find((w) => w.id === app.id);
          let url = app.url;
          let view = { id:app.id, deepLink: dpLinkUrl, type:'application', name:app.name, url:app.url, icon:app.icon,iconText:app.iconText , logoutUrl: app.logoutUrl};
          if(wview && wview.visitedPath && wview.visitedOrigin && wview.index === 0 ){
            url = wview.visitedOrigin + wview.visitedPath;
            view = { ...view, url } as any;
            removeWebView(wview.id);
          }
            resetActive();
            addWebView(view);
        }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps 
  },[appId, dpLink, applications]);

  return <></>
}

export function CustomView(){
  return <></>
}

export function WorkflowView() {
  const { appId, dpLink} = useParams() as any;
  const { workflowId } = useParams() as any;
  const { applications } = useApplicationStore();
  const {fromUniversity} = useParams() as any;
  const {addWebView,webviews,resetActive} = useWebViewStore();
  const {setIsLoading,setName} = useStore() as any;
  const startupWorkflowUrl = useStartupWorkflowStore((state) => state.startupWorkflowUrl);
  const clearStartupWorkflowUrl = useStartupWorkflowStore((state) => state.clearStartupWorkflowUrl);

  useEffect(()=>{
    if(appId && workflowId){

        const app = applications?.find((app: any) => app.id === appId);
        const workflow = app?.workflows?.find((workflow:any) => workflow.workflowId === workflowId);

      if (!app || !workflow) {
       clearStartupWorkflowUrl();
        return;
      }

      let dpLinkUrl = '';
      if(dpLink){
         try{
          dpLinkUrl = JSON.parse(atob(window.location?.href.split('bdp')[1] || '{}'))?.url;
        } catch(_) {
          if(window.top){
            window.top.location.href = window.top.location.origin;
          }
          return;
        }
      }

      const urlToUse = startupWorkflowUrl || workflow.url;
      if (startupWorkflowUrl) {
        clearStartupWorkflowUrl();
      }

      const isLaunced = launchExternal(urlToUse);
      const isExist = webviews.some((i) => i.id === workflow.workflowId);
      if(!isExist && !isLaunced){
        setIsLoading(true);
        let viewName =workflow.name+" Workflow";
        fromUniversity === 'Y' && (viewName = workflow.name + " - CDK University");
        setName(viewName);
      }

      if(fromUniversity === 'Y'){
        const cdkuApp = applications?.find((app: any) => app.id === 'CDKU');
        const view = { id:cdkuApp.id, deepLink: dpLinkUrl, type:'workflow', name:cdkuApp.name, url:workflow.cdkuUrl, icon:cdkuApp.icon,iconText:cdkuApp.iconText, logoutUrl: cdkuApp.logoutUrl };
        addWebView(view);
      }else{
        // Use startupUrl directly if available — skips the app home page entirely
        let view = { id:workflow.workflowId, deepLink: dpLinkUrl, type:'workflow', appId:workflow.appId, name:workflow.name, url:urlToUse, icon:workflow.icon,iconText:workflow.iconText, logoutUrl: workflow.logoutUrl };
        resetActive();
        addWebView(view);
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps         
  },[appId, dpLink,  workflowId,applications]);

  return <></>
}